export default __webpack_public_path__ + "static/media/ViewAllPositions.173f7f37.svg";